module.exports = __webpack_public_path__ + "static/media/pic7.54047844.jpg";